const GA_MEASUREMENT_ID = 'G-9BP4W38ND5';
let hasInitialized = false;

const isTestEnv = () => typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';

export const initializeAnalytics = () => {
  if (hasInitialized || typeof window === 'undefined' || isTestEnv()) {
    return;
  }

  hasInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  const existingScript = document.querySelector('script[data-google-analytics="true"]');
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.setAttribute('data-google-analytics', 'true');
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
};

export const trackPageView = (pagePath) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' || isTestEnv()) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: document.title,
    page_location: window.location.href,
  });
};
